const ApiPrefix = '/api/v1'
const paths = {
  databaseSync: `${ApiPrefix}/databases/sync`,
  dataVerificationHashJsonFileDownload: (jobId: string) => `${ApiPrefix}/jobs/data-verification-hash/${jobId}`,
}
export default paths
